import library from "./library";

const packages = {
    "P5": {
        "template": "P_base",
        "T8F1":  { "target": "f2List" },
        "T9F1":  { "target": "f2List" },
        "T10F1": { "target": "f2List" },
        "T13F1": { "target": "f2List" },
        "T13F2": { "target": "f2List" },
        "T12F1": { "target": "f3List", "title": "父母依恋关系" },
        "T12F2": { "target": "f3List" },
        "T12F3": { "target": "f3List" },
        "T12F4": { "target": "f3List" },
        "T12F5": { "target": "f3List" },
        "T12F6": { "target": "f3List" }
    },
    "P7": {
        "template": "P7",
        "T19F1": { "target": "f2List" },
        "T19F2": { "target": "f2List" },
        "T16F1": { "target": "f2List" }
    },
    "P8": {
        "template": "P8",
        "T17F1": { "target": "f2List" },
        "T17F2": { "target": "f2List" },
        "T18F1": { "target": "f2List" }
    },
    "P9": {
        "template": "P_base",
        "T20F2": { "target": "f2List" },
        "T20F3": { "target": "f2List" },
        "T20F4": { "target": "f2List" },
        "T20F5": { "target": "f2List" },
        "T20F6": { "target": "f2List" },
        "T20F7": { "target": "f2List" },
        "T20F8": { "target": "f2List" },
        "T20F9": { "target": "f2List" }
    },
    "P10": {
        "template": "P_base",
        "T8F1":  { "target": "f2List" },
        "T14F1": { "target": "f2List" },
        "T15F1": { "target": "f2List" },
        "T12F1": { "target": "f3List", "title": "父母依恋关系" },
        "T12F2": { "target": "f3List" },
        "T12F3": { "target": "f3List" },
        "T12F4": { "target": "f3List" },
        "T12F5": { "target": "f3List" },
        "T12F6": { "target": "f3List" }
    },
    "P11": {
        "template": "P11",
        "T22F1": { "target": "f2List" },
        "T22F2": { "target": "f2List" },
        "T22F3": { "target": "f2List" },
        "T22F4": { "target": "f2List" },
        "T22F5": { "target": "f2List" },
        "T22F6": { "target": "f2List" },
        "T22F7": { "target": "f2List" },
        "T22F8": { "target": "f2List" },
        "T22F9": { "target": "f2List" }
    },
    "P17": {
        "template": "P_base",
        "T40F2": { "target": "f2List" },
        "T40F3": { "target": "f2List" },
        "T40F4": { "target": "f2List" },
        "T40F5": { "target": "f2List" },
        "T40F6": { "target": "f2List" },
        "T40F7": { "target": "f2List" },
        "T40F8": { "target": "f2List" },
        "T40F9": { "target": "f2List" }
    },
    "P18": {
        "template": "P_base",
        "T8F1":  { "target": "f2List" },
        "T9F1":  { "target": "f2List" },
        "T10F1": { "target": "f2List" },
        "T11F2": { "target": "f2List" },
        "T13F1": { "target": "f2List" },
        "T13F2": { "target": "f2List" },
        "T12F1": { "target": "f3List", "title": "父母依恋关系" },
        "T12F2": { "target": "f3List" },
        "T12F3": { "target": "f3List" },
        "T12F4": { "target": "f3List" },
        "T12F5": { "target": "f3List" },
        "T12F6": { "target": "f3List" }
    },
    "P19": {
        "template": "P_base",
        "T41F1": { "target": "f2List" }
    },
    "P20": {
        "template": "P_base",
        "T42F1": { "target": "f2List" },
        "T42F2": { "target": "f2List" },
        "T42F3": { "target": "f2List" },
        "T42F4": { "target": "f2List" },
        "T42F5": { "target": "f2List" },
        "T42F6": { "target": "f2List" },
        "T42F7": { "target": "f2List" }
    },
    "P21": {
        "template": "P_base",
        "T43F1": { "target": "f2List" },
        "T43F2": { "target": "f2List" },
        "T43F3": { "target": "f2List" },
        "T43F4": { "target": "f2List" },
        "T43F5": { "target": "f2List" }
    },
    "P22": {
        "template": "P_base",
        "T44F1": { "target": "f2List" },
        "T44F2": { "target": "f2List" },
        "T44F3": { "target": "f2List" },
        "T44F4": { "target": "f2List" },
        "T44F5": { "target": "f2List" },
        "T44F6": { "target": "f2List" },
        "T44F7": { "target": "f2List" },
        "T44F8": { "target": "f2List" },
        "T44F9": { "target": "f2List" },
        "T44F10": { "target": "f2List" },
        "T44F11": { "target": "f2List" }
    },
    "P23": {
        "template": "P_base",
        "T45F1": { "target": "f2List" },
        "T45F2": { "target": "f2List" },
        "T45F3": { "target": "f2List" }
    },
    "P24": {
        "template": "P_base",
        "T46F1": { "target": "f2List" }
    },
    "P25": {
        "template": "P_base",
        "T47F1": { "target": "f2List" },
        "T47F2": { "target": "f2List" },
        "T47F3": { "target": "f2List" },
        "T47F4": { "target": "f2List" }
    },
    "P26": {
        "template": "P_base",
        "T48F1": { "target": "f2List" },
        "T48F2": { "target": "f2List" },
        "T48F3": { "target": "f2List" },
        "T48F4": { "target": "f2List" }
    },
    "P27": {
        "template": "P_base",
        "T49F1": { "target": "f2List" }
    },
    "P28": {
        "template": "P_base",
        "T50F1": { "target": "f2List" }
    },
    "P29": {
        "template": "P_base",
        "T51F1": { "target": "f2List" },
        "T51F2": { "target": "f2List" },
        "T51F3": { "target": "f2List" },
        "T51F4": { "target": "f2List" }
    },
    "P30": {
        "template": "P_base",
        "T52F1": { "target": "f2List" },
        "T52F2": { "target": "f2List" },
        "T52F3": { "target": "f2List" },
        "T52F4": { "target": "f2List" },
        "T52F5": { "target": "f2List" },
        "T52F6": { "target": "f2List" },
        "T52F7": { "target": "f3List", "title": "主观幸福感水平" }
    },
    "P31": {
        "template": "P_base",
        "T53F1": { "target": "f2List" },
        "T53F2": { "target": "f2List" },
        "T53F3": { "target": "f2List" },
        "T53F4": { "target": "f2List" },
    }
};

function parseReportConfig(raw) {
    if (!raw) return null;
    try {
        return JSON.parse(raw);
    } catch (e) {
        try {
            return new Function("return (" + raw + ")")();
        } catch (e2) {
            console.warn("[factorRanges] invalid reportConfig", e2);
            return null;
        }
    }
}

function parseFormula(formula) {
    const s = formula.replace(/\s/g, "");

    if (s.includes("&&")) {
        const parts = s.split("&&");
        if (parts.length !== 2) throw new Error("范围格式只能有两个条件");

        const conds = parts.map(p => parseCondition(p));
        if (conds[0].var !== conds[1].var)
            throw new Error("两个条件必须使用同一变量");

        const [c1, c2] = conds;
        const ops = [c1.op, c2.op];
        const vals = [c1.val, c2.val];

        const lowerOps = [">=", ">"];
        const upperOps = ["<=", "<"];

        let lowerIdx = -1,
            upperIdx = -1;
        for (let i = 0; i < 2; i++) {
            if (lowerOps.includes(ops[i])) {
                if (lowerIdx !== -1) throw new Error("只能有一个下限运算符");
                lowerIdx = i;
            } else if (upperOps.includes(ops[i])) {
                if (upperIdx !== -1) throw new Error("只能有一个上限运算符");
                upperIdx = i;
            } else {
                throw new Error("不支持的运算符: " + ops[i]);
            }
        }

        if (lowerIdx === -1 || upperIdx === -1) {
            throw new Error("必须同时包含一个下限运算符和一个上限运算符");
        }

        const minVal = vals[lowerIdx];
        const maxVal = vals[upperIdx];
        if (minVal > maxVal) throw new Error("下限值不能大于上限值");
        if (minVal === maxVal && ops[lowerIdx] === ">" && ops[upperIdx] === "<") {
            throw new Error("区间为空");
        }

        return {
            min: minVal,
            max: maxVal,
            sn: ops[lowerIdx],
            sx: ops[upperIdx]
        };
    } else {
        const c = parseCondition(s);
        if (c.op === "==" || c.op === "===") {
            return {
                val: c.val,
                se: c.op
            };
        }
        if ([">=", ">", "<=", "<"].includes(c.op)) {
            if ([">=", ">"].includes(c.op)) {
                return { min: c.val, max: c.val, sn: c.op, sx: "<=" };
            } else {
                return { min: c.val, max: c.val, sn: ">=", sx: c.op };
            }
        }
        throw new Error("不支持的运算符: " + c.op);
    }
}

function parseCondition(cond) {
    const match = cond.match(/^([A-Za-z]\d*)([<>=!]+)(\d+(?:\.\d+)?)$/);
    if (!match) throw new Error("无效的条件格式: " + cond);
    const [, varName, op, numStr] = match;
    return {
        var: varName,
        op: op,
        val: parseFloat(numStr)
    };
}

const cache = {};

async function get(vm, pkgId) {
    const key = "P" + pkgId;

    if (cache[key]) {
        return cache[key];
    }

    const data = await library.reqAsy.call(vm, {
        url: "/pkg_report_config?pkgId=" + pkgId,
        data: {},
        method: "get",
        loadingFlag: false
    });

    if (data && data.success) {
        const obj = data.obj || {};
        let pkgConfig = parseReportConfig(obj.reportConfig);
        if (!pkgConfig) {
            pkgConfig = packages[key];
        }
        if (!pkgConfig) {
            console.warn("[factorRanges] unknown package: " + key);
            return null;
        }

        const list = obj.resList || [];

        const grouped = {};
        list.forEach(function (item) {
            const varMatch = item.formula.match(/^([A-Za-z]\d*)/);
            const factorNo = varMatch ? varMatch[1] : "F1";
            const factorKey = "T" + item.scaleId + factorNo;
            if (!grouped[factorKey]) {
                grouped[factorKey] = [];
            }
            grouped[factorKey].push(item);
        });

        const scaleFactors = {};
        for (const [factorKey, items] of Object.entries(grouped)) {
            try {
                items.sort(function (a, b) {
                    const aNo = parseInt((a.resNo || "").replace(/\D/g, "")) || 0;
                    const bNo = parseInt((b.resNo || "").replace(/\D/g, "")) || 0;
                    return aNo - bNo;
                });
    
                const ranges = items.map(function (item) {
                    const parsed = parseFormula(item.formula);
                    return Object.assign({}, parsed, {
                        color: item.color,
                        res: item.resName,
                        resDesc: item.description
                    });
                });
    
                let min = Infinity,
                    max = -Infinity;
                ranges.forEach(function (r) {
                    if (r.min !== undefined) {
                        if (r.min < min) min = r.min;
                        if (r.max > max) max = r.max;
                    } else if (r.val !== undefined) {
                        if (r.val < min) min = r.val;
                        if (r.val > max) max = r.val;
                    }
                });
    
                scaleFactors[factorKey] = { min: min, max: max, ranges: ranges };
            } catch (err) {
                console.error('res ranges formula 解析失败', err);
            }
        }

        const result = { template: pkgConfig.template };
        for (const [factorKey, factorConfig] of Object.entries(pkgConfig)) {
            if (factorKey === "template") continue;
            if (scaleFactors[factorKey]) {
                result[factorKey] = Object.assign({}, scaleFactors[factorKey], {
                    target: factorConfig.target,
                    title: factorConfig.title
                });
            }
        }

        cache[key] = result;
        return result;
    }

    throw new Error("[factorRanges] fetch failed for " + key);
}

export default { get };


// WEBPACK FOOTER //
// ./src/js/factorRanges.js